import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
import Upload from '../../component/Inc/Upload';
function PopStudentDetail(props) {
  const {open, close} = props;
  const [modalPassword, setModalPassword] = useState(false);
  return (
    <Modal open={open} close={close} type="com_input com_student_detail pop_student_detail">
      <h2 className="pop_tit">학생 정보</h2>
      <div className="content_container scroll">
        <table className="com_board_list type_row">
          <colgroup>
            <col width="25%" />
            <col width="75%" />
          </colgroup>
          <tbody>
            <tr>
              <th>이름</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <input type="text" className="input" defaultValue={`홍길동201`} />
                </div>
              </td>
            </tr>
            <tr>
              <th>학교</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <select className="select wm2">
                    <option value="경기도">경기도</option>
                    <option value="서울">서울</option>
                  </select>
                  <select className="select wm2">
                    <option value="서울고등학교">서울고등학교</option>
                    <option value="경기고등학교">경기고등학교</option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <th>생년월일 / 성별</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <div className="check">
                    <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                    <label htmlFor="rdo01">남</label>
                    <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                    <label htmlFor="rdo02">여</label>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>희망대 (학과)</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <input type="text" className="input" defaultValue={`한국방송통신대`} />
                  <input type="text" className="input" defaultValue={`미디어영상학과`} />
                </div>
              </td>
            </tr>
            <tr>
              <th>아이디</th>
              <td className="td_left">asdlfkjalkdj</td>
            </tr>
            <tr>
              <th>비밀번호</th>
              <td className="td_left">
                <div className="com_input_wrap flex_between">
                  <div>
                    <input type="text" className="input" defaultValue={`@@1312`} />
                  </div>
                  <button onClick={() => setModalPassword(true)} className="com_btn gray s">
                    비밀 번호 변경 전송
                  </button>
                </div>
              </td>
            </tr>
            <tr>
              <th>입회일</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                </div>
              </td>
            </tr>
            <tr>
              <th>입회학년</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <select className="select wm">
                    <option value="2021">2021</option>
                  </select>
                  <select className="select wm">
                    <option value="중1">중1</option>
                  </select>
                  <select className="select wm">
                    <option value="인문">인문</option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <th>현재 학년</th>
              <td className="td_left">
                <div className="com_input_wrap flex_row">
                  <select className="select">
                    <option value="중2">중2</option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <th>현재 학년 사유</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <select className="select">
                    <option value="유급1년">유급1년</option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <th>휴대폰</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <input type="text" className="input" defaultValue={`010-222-2222`} />
                </div>
              </td>
            </tr>
            <tr>
              <th>이메일</th>
              <td className="type_row">
                <div className="com_input_wrap">
                  <input type="text" className="input" />
                </div>
              </td>
            </tr>
            <tr>
              <th>담임</th>
              <td>
                <section className="com_board_search end">
                  <article className="search">
                    <input type="search" placeholder="담임명 검색" className="input s type_search" />
                    <button className="com_btn gray ws s icon_search"></button>
                  </article>
                </section>
              </td>
            </tr>
            <tr>
              <th>특별관리회원</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <div className="check">
                    <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                    <label htmlFor="chk01" />
                  </div>
                  <input type="text" className="input wl" placeholder="사유 입력" />
                </div>
              </td>
            </tr>
            <tr>
              <th>부모 휴대폰</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <input type="text" className="input" defaultValue={`010-222-2222`} />
                  <input type="text" className="input" defaultValue={`010-222-2222`} />
                </div>
              </td>
            </tr>
            <tr>
              <th>학부모 메일</th>
              <td className="type_row">
                <div className="com_input_wrap">
                  <input type="text" className="input" />
                </div>
              </td>
            </tr>
            <tr>
              <th>홍보문자 수신</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <div className="check">
                    <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                    <label htmlFor="rdo03">수신</label>
                    <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                    <label htmlFor="rdo04">거부</label>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>생기부파일</th>
              <td className="type_row">
                <div className="com_input_wrap flex_row">
                  <div className="com_input_upload">
                    <input type="text" className="input" />
                    <Upload title="파일 등록" className="com_btn gray xs wl" />
                  </div>
                  <button className="com_btn xs btn_request orange btn_attatch_orange">생기부 파일 업로드링크 전송</button>
                </div>
              </td>
            </tr>
            <tr>
              <th>가상 계좌</th>
              <td className="type_row">
                <div className="com_input_wrap flex_row">
                  <input type="text" className="input wl" />
                  <button className="com_btn xs btn_request orange btn_msg_orange">문자 전송</button>
                </div>
              </td>
            </tr>
            <tr>
              <th>환불 계좌</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <input type="text" className="input ws" placeholder="예금주" />
                  <input type="text" className="input wl" placeholder="계좌번호" />
                </div>
              </td>
            </tr>
            <tr>
              <th>주소</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <input type="text" className="input wl" />
                  <button className="com_btn gray xs">우편번호</button>
                </div>
              </td>
            </tr>
            <tr>
              <th>상세주소</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <input type="text" className="input wl" />
                </div>
              </td>
            </tr>
            <tr>
              <th>약도</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <input type="text" className="input wl" />
                </div>
              </td>
            </tr>
            <tr>
              <th rowSpan={2}>학습환경</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <select className="select wm2">
                    <option value="관심정도 최상">관심정도 최상</option>
                  </select>
                  <select className="select wm2">
                    <option value="지원정도 최상">지원정도 최상</option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <td className="border_left">
                <div className="com_input_wrap flex_row">
                  <select className="select wm2">
                    <option value="가정형편 최상">가정형편 최상</option>
                  </select>
                  <select className="select wm2">
                    <option value="내신성적 최상">내신성적 최상</option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <th>메모</th>
              <td>
                <textarea name="" className="textarea" placeholder="메모 입력" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">확인</button>
        <button className="com_btn line orange xs btn_detail">상세 페이지로 이동</button>
      </div>
      <Modal open={modalPassword} close={() => setModalPassword(false)} type="type_alert">
        <div className="content_container mb_no">
          <div className="txt">
            비밀번호가 자동 변경되고,
            <br />
            당사자에게 문자 정송됩니다.
          </div>
        </div>
        <div className="btn_container">
          <button className="com_btn lightGray xs">취소</button>
          <button className="com_btn orange xs">확인</button>
        </div>
      </Modal>
    </Modal>
  );
}

export default PopStudentDetail;
